<template>
  <div v-if="isVisible" class="save-modal-backdrop" @click.self="closeModal">
    <section
      class="save-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="save-modal-title"
      aria-describedby="save-modal-message"
    >
      <header class="save-modal-header">
        <div class="save-modal-icon" aria-hidden="true">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div class="save-modal-heading">
          <h3 id="save-modal-title">Modifiche non salvate</h3>
          <p class="save-modal-eyebrow">Conferma di uscita</p>
        </div>
      </header>

      <p id="save-modal-message" class="save-modal-message">
        {{ message }}
      </p>

      <div class="save-modal-actions">
        <button
          @click="closeModal"
          class="save-modal-button save-modal-button--secondary"
        >
          Annulla
        </button>
        <button
          @click="emitDiscard"
          class="save-modal-button save-modal-button--danger"
        >
          Esci senza salvare
        </button>
        <button
          @click="emitSave"
          class="save-modal-button save-modal-button--primary"
        >
          <i class="fa-solid fa-floppy-disk"></i>
          Salva modifiche
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SalvaModifiche",
  props: {
    message: {
      type: String,
      default: "Vuoi salvare le modifiche apportate?",
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    emitSave() {
      this.$emit("save");
    },
    emitDiscard() {
      this.$emit("discard");
    },
  },
};
</script>

<style scoped>
.save-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9990;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(18, 24, 32, 0.56);
}

.save-modal {
  width: min(36rem, 100%);
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #d9dde3;
  border-radius: 10px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
  color: #252a31;
}

.save-modal-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.9rem;
  padding: 1.2rem 1.4rem;
  background: #f5f6f8;
  border-bottom: 1px solid #e2e5e9;
}

.save-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  color: #8f5f1a;
  background: #fff4dd;
  border: 1px solid #f0d6a3;
  border-radius: 50%;
}

.save-modal-icon i {
  font-size: 1.15rem;
}

.save-modal-heading h3 {
  margin: 0;
  font-size: 1.18rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
}

.save-modal-eyebrow {
  margin: 0.22rem 0 0;
  color: #6a717d;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: left;
}

.save-modal-message {
  margin: 0;
  padding: 1.35rem 1.5rem;
  color: #3f4651;
  font-size: 1rem;
  line-height: 1.5;
  white-space: pre-wrap;
  text-align: left;
}

.save-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  padding: 1rem 1.25rem 1.2rem;
  background: #fafafa;
  border-top: 1px solid #e2e5e9;
}

.save-modal-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 9rem;
  min-height: 2.55rem;
  padding: 0.68rem 1.05rem;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 0.94rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
    box-shadow 0.2s ease;
}

.save-modal-button--primary {
  color: #ffffff;
  background: #1474bd;
  border-color: #1474bd;
}

.save-modal-button--primary:hover {
  background: #115f9b;
  border-color: #0f568d;
}

.save-modal-button--danger {
  color: #ffffff;
  background: #d93f4b;
  border-color: #d93f4b;
}

.save-modal-button--danger:hover {
  background: #c4323e;
  border-color: #b82f3a;
}

.save-modal-button--secondary {
  color: #374151;
  background: #eef1f4;
  border-color: #d5dce4;
}

.save-modal-button--secondary:hover {
  background: #e3e8ed;
  border-color: #c4ced8;
}

@media (max-width: 640px) {
  .save-modal-header {
    align-items: flex-start;
  }

  .save-modal-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .save-modal-button {
    width: 100%;
  }
}
</style>
